import http from '../../../plugins/axios';

export default {
    getSupportCoinDeposit() {
        return http.get({
            url: '/admin/transfer/getWalletCoin'
        })
    },
    downExcel() {
        return http.get({
            url: '/admin/transfer/export/excel/moulds',
            responseType: 'blob'
        })
    },
    getSupportCoinTransfer() {
        return http.get({
            url: '/admin/transfer/getTransferCoin'
        })
    },

    balanceChangeForWallet(data) {
        return http.post({
            url: '/admin/transfer/toWallet',
            data,
            dataType: 'form'
        })
    },

    balanceChangeForInternalTransfer(data) {
        return http.post({
            url: '/admin/transfer/internal',
            data,
            dataType: 'form'
        })
    },

    selectTransferInfo(data){
        return http.post({
            url: '/admin/transfer/query',
            data,
            dataType:'form'
        })
    },

    exportTransferInfo(data){
        return http.post({
            url: '/admin/transfer/export',
            data,
            dataType:'form',
            responseType: 'blob'
        })
    },

    queryAirDropSuccess(data){
         return http.get({
             url : '/admin/airDropTask/mining//list/task',
             data
         })
    },

    queryListAirSuccessRecord(data) {
        return http.get({
            url: '/admin/airDropTask/mining/list/airdrop',
            data
        })
    },

    sameAccountTransfer(data) {
        return http.post({
            url: '/admin/transfer/diffWalletType',
            data,
            dataType:'form'
        })
    }
}
